import { defineComponent as d, createElementBlock as s, openBlock as o, mergeProps as c, unref as n, createVNode as p, createElementVNode as t, createCommentVNode as i, renderSlot as a, createTextVNode as u } from "vue";
import { ScalarIconMagnifyingGlass as b } from "@scalar/icons";
import { useBindCx as m } from "@scalar/use-hooks/useBindCx";
const f = { class: "flex-1 text-left leading-none" }, h = {
  key: 0,
  class: "uppercase text-sidebar-c-2 bg-b-2 leading-none py-1 px-1.25 rounded"
}, _ = /* @__PURE__ */ d({
  inheritAttrs: !1,
  __name: "ScalarSidebarSearchButton",
  props: {
    hotKey: {}
  },
  setup(x) {
    const { cx: l } = m();
    return (r, e) => (o(), s("button", c(
      {
        type: "button",
        role: "search"
      },
      n(l)(
        "flex items-center rounded border text-base h-8 gap-1 pl-2 pr-1",
        "bg-sidebar-b-search border-sidebar-border-search text-sidebar-c-search"
      )
    ), [
      p(n(b), { class: "size-4" }),
      t("span", f, [
        a(r.$slots, "default", {}, () => [
          e[0] || (e[0] = u("Search..."))
        ])
      ]),
      r.$slots.shortcut ? (o(), s("span", h, [
        e[1] || (e[1] = t("span", { class: "sr-only" }, "Keyboard Shortcut:", -1)),
        t("kbd", null, [
          a(r.$slots, "shortcut")
        ])
      ])) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
